// extracted by mini-css-extract-plugin
export var cardIcon = "_5z-5";
export var cardIconUnframed = "_5z-9";
export var checkboxCard = "_5z-0";
export var checkboxCardSelected = "_5z-4";
export var disabled = "_5z-2";
export var interactive = "_5z-1";
export var outerBorder = "_5z-3";
export var spacerMedium = "_5z-8";
export var spacerSmall = "_5z-7";
export var spacerXsmall = "_5z-6";